__turbopack_context__.v({
  "modal": "modal-module-scss-module__x2kRKG__modal",
  "modalCloseBtn": "modal-module-scss-module__x2kRKG__modalCloseBtn",
  "modalEnter": "modal-module-scss-module__x2kRKG__modalEnter",
  "modalEnterActive": "modal-module-scss-module__x2kRKG__modalEnterActive",
  "modalExit": "modal-module-scss-module__x2kRKG__modalExit",
  "modalExitActive": "modal-module-scss-module__x2kRKG__modalExitActive",
  "modalWrapper": "modal-module-scss-module__x2kRKG__modalWrapper",
});
